import { FC } from 'react'

import {
  EmbroideryIcon,
  EmbroideryIconGroup,
} from '../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { IconSelector } from '../selectors/IconSelector/IconSelector'

import { IconGroupLabel } from './styles'

interface Props {
  group: EmbroideryIconGroup
  selectedIcon: EmbroideryIcon | undefined | null
  onSelectIcon(iconImage: EmbroideryIcon): void
  productColorHex: string | undefined
}

export const EmbroideryIconGroupSection: FC<Props> = ({
  group,
  selectedIcon,
  onSelectIcon,
  productColorHex,
}) => {
  const labelId = `icon-group-${group.id}`

  return (
    <>
      <IconGroupLabel id={labelId}>{group.displayName}</IconGroupLabel>
      <IconSelector
        icons={group.icons}
        labelId={labelId}
        onSelectIcon={onSelectIcon}
        selectedIcon={selectedIcon}
        productColorHex={productColorHex}
      />
    </>
  )
}
